import cx from 'classnames'
import React, { FC, useState, useEffect } from 'react'
import Select from 'react-select'

import style from '../style.scss'

interface Props {
    data: [] | any
    id?: string
    className?: string
    tableValueHeading: string
    botNames: any
    heading?: string
}
function isNumber(value: any): value is number {
    return typeof value === 'number'
  }
const TableContainer: FC<Props> = props => {
    const { id, className, tableValueHeading, data } = props
    const [botList, setbotList]: any = useState([{ label: 'All bots', value: 'all' }])
    const [selectedOption, setSelectedOption] = useState(botList[0])
    const [selectedBotID, setSelectedBotID] = useState('')
    const [botSelected, setbotSelected] = useState(false)
    const [selectedBotData, setSelectedBotData]: any = useState({})

    const AgentPerformanceReport = {
        table: `Metrics ${selectedBotData?.linkedAgent ? '' : botSelected ? ' (Not Linked)' : ''}`,
        data: [
            {
                key: 'Total Requests',
                value: selectedBotData?.totalRequests !== undefined ? selectedBotData?.totalRequests : '-'
            },
            {
                key: 'Resolved Requests',
                value: selectedBotData?.resolvedRequests !== undefined ? selectedBotData?.resolvedRequests : '-'
            },
            {
                key: 'Unassigned Requests',
                value: selectedBotData?.unassignedRequests !== undefined ? selectedBotData?.unassignedRequests : '-'
            },
            {
                key: 'Expired Requests',
                value: selectedBotData?.expiredRequests !== undefined ? selectedBotData?.expiredRequests : '-'
            },
            {
                key: 'Video Call Response',
                value: selectedBotData?.videoSessions !== undefined ? selectedBotData?.videoSessions : '-'
            },
            {
                key: 'Audio Call Response',
                value: selectedBotData?.voiceSessions !== undefined ? selectedBotData?.voiceSessions : '-'
            },
            {
                key: 'Average Resolve Time',
                value: selectedBotData?.resolveTime ? selectedBotData?.resolveTime : '-'
            },
            // {
            //     key: 'First Call Resolution Rate',
            //     value: selectedBotData?.firstCallResolutionRate ? selectedBotData?.firstCallResolutionRate : '-'
            // },
            // {
            //     key: 'Quality Rate',
            //     value: selectedBotData?.qualityRate ? selectedBotData?.qualityRate : '-'
            // },
        ]
    }

    useEffect(() => {
        let botLists: any = [{ label: 'All Bots', value: 'all' }]
        data.map(botId => {
            if (props.botNames[botId.botId]) {
                const botName = props.botNames[botId.botId]
                botLists.push({ label: botName, value: botId.botId })
            }
        })
        setbotList(botLists)
        // console.log('setBotList:: ', botLists)
    }, [data])


    useEffect(() => {
        if (botSelected) {
            const selectedBotData = data.filter(botData => botData.botId === selectedBotID)
            let totals = {
                totalRequests: selectedBotData[0]?.totalRequests,
                resolvedRequests: selectedBotData[0]?.totalRequests,
                unassignedRequests: selectedBotData[0]?.unassignedRequests,
                expiredRequests: selectedBotData[0]?.expiredRequests,
                videoSessions: selectedBotData[0]?.videoSessions,
                voiceSessions: selectedBotData[0]?.voiceSessions,
                resolveTime: selectedBotData[0]?.resolveTime, // in seconds
                linkedAgent: selectedBotData[0]?.linkedAgent
            }
            let averageResolveTime: any = totals.resolvedRequests ? (totals.resolveTime / totals.resolvedRequests) : 0
            averageResolveTime = secondsToHMS(Math.floor(averageResolveTime))
            totals.resolveTime = averageResolveTime
            setSelectedBotData(totals)
        } else {
            let totals = {
                totalRequests: 0,
                resolvedRequests: 0,
                unassignedRequests: 0,
                expiredRequests: 0,
                videoSessions: 0,
                voiceSessions: 0,
                resolveTime: 0 // in seconds
            }
            data.forEach(item => {
                totals.totalRequests += isNumber(item.totalRequests) ? item.totalRequests : 0
                totals.resolvedRequests += isNumber(item.resolvedRequests) ? item.resolvedRequests : 0
                totals.unassignedRequests += isNumber(item.unassignedRequests) ? item.unassignedRequests : 0
                totals.expiredRequests += isNumber(item.expiredRequests) ? item.expiredRequests : 0
                totals.videoSessions += isNumber(item.videoSessions) ? item.videoSessions : 0
                totals.voiceSessions += isNumber(item.voiceSessions) ? item.voiceSessions : 0
                totals.resolveTime += isNumber(item.resolveTime) ? item.resolveTime : 0
            })
            let averageResolveTime: any = totals.resolvedRequests ? (totals.resolveTime / totals.resolvedRequests) : 0
            averageResolveTime = secondsToHMS(Math.floor(averageResolveTime))
            totals.resolveTime = averageResolveTime
            setSelectedBotData(totals)
        }
    }, [data, selectedBotID])

    function secondsToHMS(seconds) {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        return `${minutes}m ${remainingSeconds}s`
    }

    function handleSelectedBotID(option) {
        if (option.value === 'all') {
            setSelectedBotID('')
            setbotSelected(false)
        } else {
            const id = option.value
            setSelectedBotID(id)
            setbotSelected(true)
        }
    }

    function handleOptionSelect(option) {
        handleSelectedBotID(option)
        setSelectedOption(option)
    }

    return (
        <div className={cx(style.genericTable, className || '')}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>{props.heading || 'My Activity'}</h3>
                <div style={{ width: '220px' }}>
                    <Select
                        classNamePrefix={'performance-graphs'}
                        id="bots"
                        default={botList[0]}
                        maxMenuHeight={200}
                        style={{ zIndex: 1000 }}
                        options={botList}
                        value={selectedOption}
                        onChange={handleOptionSelect}
                        styles={{
                            container: (styles) => ({
                                ...styles,
                                width: '100%',
                                fontSize: '12px',
                            }),
                            control: (styles) => ({
                                ...styles,
                                minHeight: '25px',
                                height: '25px',
                            }),
                            dropdownIndicator: (styles) => ({
                                ...styles,
                                padding: '0px 4px'
                            })
                        }}
                    />
                </div>
            </div>
            <table id={id} width={'100%'}>
                <tr>
                    <th>{AgentPerformanceReport.table}</th>
                    <th>{tableValueHeading}</th>
                </tr>
                {
                    AgentPerformanceReport.data?.map(item => <tr>
                        <td>{item.key}</td>
                        <td>{item.value}</td>
                    </tr>
                    )
                }
            </table>
        </div>
    )
}

export default TableContainer
